import React from 'react';
import { useTranslation } from 'react-i18next';
import SEOHead from '../components/SEOHead';
import typAnimation from '../assets/typ.webm';

const ThankYouPage = () => {
  const { t, i18n } = useTranslation('pages');
  const title = t('thankYou.title');
  const buttonLabel = t('thankYou.button');
  const basePath = i18n.language === 'ru' ? '/ru' : '';
  return (
    <>
      <SEOHead page="thankYou" />
      <div className='container' style={{ minHeight: '70vh', padding: '80px 0' }}>
        <div className='row'>
          <div className='col-lg-8 mx-auto tc'>
            <div className='s-48'></div>
            
            <h1 className='title-sub' style={{ color: '#28a745', marginBottom: '32px' }}>
              {title}
            </h1>
            <div className='s-32'></div>
            
            {/* Animation */}
            <div style={{ 
              minHeight: '400px', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              marginBottom: '40px'
            }}>
              <video 
                src={typAnimation}
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                style={{ 
                  maxWidth: '100%', 
                  maxHeight: '400px',
                  objectFit: 'contain'
                }}
              />
            </div>
            
            <div style={{ marginTop: '48px' }}>
              <a href={`${basePath}/`} className='button'>
                {buttonLabel}
              </a>
            </div>
            
            <div className='s-48'></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ThankYouPage; 
